import { z } from "zod";

export const ROLES_PAGE_SIZE = 25;

export interface RolesFilters {
	status: "active" | "archived" | "any";
}

export const DEFAULT_FILTERS: RolesFilters = { status: "active" };

export const RolesFilterFormSchema = z.object({
	status: z.enum(["active", "archived", "any"]),
});

export type RolesFilterForm = z.infer<typeof RolesFilterFormSchema>;

export const STATUS_LABELS = {
	any: "Any",
	active: "Active",
	archived: "Archived",
} satisfies Record<RolesFilters["status"], string>;

export const STATUS_OPTIONS = (["any", "active", "archived"] as const).map((value) => ({
	value,
	label: STATUS_LABELS[value],
}));
